export default function initSocialLinks() {
  document.addEventListener('click', function (event) {
    var pendingLink = event.target.closest('[data-social-pending]');
    if (!pendingLink) return;

    window.alert('Link pending');
  });
}
